import React from 'react';
import { connect } from 'react-redux';

import { RecipesRoot } from 'redux/modules/recipes/reducers';
import { getRecipe } from 'redux/modules/recipes/selectors';
import { getPageNotFound } from 'redux/modules/cms-page/selectors';

import Content from 'components/Recipes/Content';

const mapStateToProps = (state: RecipesRoot) => ({
  recipe: getRecipe(state),
  pageNotFound: getPageNotFound(state),
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(Content as unknown as React.FC);
